import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { ShiftDatesDrawer } from './drawer';

export const ShiftDates = ({
  projectId,
  ganttRef,
  setBaseline,
}: {
  projectId: number;
  ganttRef: any;
  setBaseline: (index?: number) => void;
}) => {
  const [showDrawer, setShowDrawer] = useState(false);

  const onClick = useCallback(() => setShowDrawer(true), []);
  const onClose = useCallback(() => setShowDrawer(false), []);

  return (
    <>
      <Button size="small" onClick={onClick}>
        <FormattedMessage id="timeline.shift_dates.button.text" />
      </Button>
      {showDrawer ? (
        <ShiftDatesDrawer
          projectId={projectId}
          onClose={onClose}
          ganttRef={ganttRef}
          setBaseline={setBaseline}
        />
      ) : null}
    </>
  );
};
